import { render, staticRenderFns } from "./MobGlobe.vue?vue&type=template&id=3ebeddd8&scoped=true"
import script from "./MobGlobe.vue?vue&type=script&lang=js"
export * from "./MobGlobe.vue?vue&type=script&lang=js"
import style0 from "./MobGlobe.vue?vue&type=style&index=0&id=3ebeddd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_1ea54a5d08821f18e5f7625cad052d96/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebeddd8",
  null
  
)

export default component.exports